/**
 * Do not edit directly
 * Generated on Mon, 15 Apr 2024 06:34:26 GMT
 */
const tokens = {
    component: {
        accordion: {
            paddingHorizontal: {
                value: "20px",
                type: "dimension",
            },
            paddingVertical: {
                value: "16px",
                type: "dimension",
            },
            fontSize: {
                value: "1.125rem",
                type: "dimension",
            },
            fontWeight: {
                value: 400,
                type: "fontWeight",
            },
            lineHeight: {
                value: "1.5rem",
                type: "dimension",
            },
            gap: {
                value: "20px",
                type: "dimension",
            },
            borderBottomColor: {
                value: "#e6e6e6",
                type: "color",
            },
            borderBottomWidth: {
                value: "1px",
                type: "dimension",
            },
            color: {
                value: "#1e1e1e",
                type: "color",
            },
            backgroundColor: {
                value: "#ffffff",
                type: "color",
            },
            icon: {
                color: {
                    value: "#1e1e1e",
                    type: "color",
                },
            },
            content: {
                paddingHorizontal: {
                    value: "20px",
                    type: "dimension",
                },
                paddingVertical: {
                    value: "16px",
                    type: "dimension",
                },
            },
            hover: {
                color: {
                    value: "#1e1e1e",
                    type: "color",
                },
                backgroundColor: {
                    value: "#94949429",
                    type: "color",
                },
            },
            active: {
                color: {
                    value: "#1e1e1e",
                    type: "color",
                },
                backgroundColor: {
                    value: "#94949452",
                    type: "color",
                },
            },
            disabled: {
                color: {
                    value: "#b3b3b3",
                    type: "color",
                },
            },
        },
    },
};
export default tokens;
